import "core-js/stable"
import "regenerator-runtime/runtime"
import React, { useState } from 'react'
import PropTypes from "prop-types"
import Form from "./Form.js"

const propTypes = {
  bank_account: PropTypes.object.isRequired
}

const New = (props) => {
  return (
    <div>
      <h1>振込先口座の指定</h1>
      <Form bank_account={props.bank_account} method={"post"} />
    </div>
  )
}

New.propTypes = propTypes

export default New
